/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 * Strict migration of AngularJS ActionMenu for user activity table to React/TypeScript
 */

import React, { useEffect, useState } from 'react'
import ActionsMenu from '~/components/shared/ActionsMenu'
import { toast } from '~/services/toast'
import { useTranslation } from 'react-i18next'
import DetailsModal from './DetailsModal'

interface ActivityRow {
  id?: number
  createdAt?: string | number
  createdById?: number
  createdByName?: string
  action?: string
  itemText?: string
  itemId?: number
  detail?: any
  esignatureType?: string
}

interface TableMenuProps {
  row: ActivityRow
}

const TableMenu: React.FC<TableMenuProps> = ({ row }) => {
  const { t: translate } = useTranslation()
  const [options, setOptions] = useState<any[]>([])
  const [showDetailModal, setShowDetailModal] = useState(false)

  useEffect(() => {
    const menu: any[] = []
    if (row.detail && row.action !== 'Documents Migrated') {
      menu.push({
        value: 'SEE_DETAILS',
        label: translate('SEE_DETAILS'),
        action: () => {
          setShowDetailModal(true)
        }
      })
    }
    if (row.esignatureType) {
      menu.push({
        value: 'ESIGNATURE',
        label: translate('ESIGNATURE'),
        action: () => {
          toast.info(translate('ACTION_ESIGNATURE'))
        }
      })
    }
    setOptions(menu)
  }, [row, translate])

  if (options.length === 0) {
    return <></>
  }

  return (
    <>
      <ActionsMenu menuId={`action-menu-activity-${row.id}`} items={options} />
      {showDetailModal && (
        <DetailsModal show={true} handleClose={() => setShowDetailModal(false)} detail={row.detail} />
      )}
    </>
  )
}

export default TableMenu
